/**
 * secureStore — wrapper expo-secure-store + fallback web (localStorage).
 *
 * Sur native iOS/Android : passthrough vers expo-secure-store (Keychain / KeyStore).
 * Sur web : expo-secure-store résout setItemAsync→undefined / getItemAsync→null,
 *   donc la session ne persiste jamais. On fallback vers localStorage avec un
 *   préfixe 'sec_' pour ne pas collisionner avec d'autres clés.
 *
 * v1.12.117 — fix persistence session web (refresh ne déconnecte plus).
 */

import { Platform } from 'react-native';
import * as RealSecureStore from 'expo-secure-store';

const WEB_PREFIX = 'sec_';

function webGet(key) {
  try {
    if (typeof window === 'undefined' || !window.localStorage) return null;
    return window.localStorage.getItem(WEB_PREFIX + key);
  } catch { return null; }
}

function webSet(key, value) {
  try {
    if (typeof window === 'undefined' || !window.localStorage) return;
    window.localStorage.setItem(WEB_PREFIX + key, String(value ?? ''));
  } catch {}
}

function webDelete(key) {
  try {
    if (typeof window === 'undefined' || !window.localStorage) return;
    window.localStorage.removeItem(WEB_PREFIX + key);
  } catch {}
}

export async function getItemAsync(key, options) {
  if (Platform.OS === 'web') return webGet(key);
  return RealSecureStore.getItemAsync(key, options);
}

export async function setItemAsync(key, value, options) {
  if (Platform.OS === 'web') { webSet(key, value); return; }
  return RealSecureStore.setItemAsync(key, value, options);
}

export async function deleteItemAsync(key, options) {
  if (Platform.OS === 'web') { webDelete(key); return; }
  return RealSecureStore.deleteItemAsync(key, options);
}

export default { getItemAsync, setItemAsync, deleteItemAsync };
